import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 13.5996L9.59961 9L5 4.40039L6.40039 3L12.4004 9L6.40039 15L5 13.5996Z" }));
export default SvgArrowRight;
